module.exports = __webpack_public_path__ + "static/img/bg-info.76f8882.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/mobile/bg-info.jpg
// module id = 667
// module chunks = 64